// Referral Form 1008 — CU-styled referral (refurl) lead form migrated from the
// Chandigarh portal InfluencerForm rendered with refType="ref". Same banner /
// solid form-header layout as Influencer Form 1007, but the form collects only
// name, email and phone before the OTP step (no course / qualification select)
// and tags the lead with the referral params from the URL.

export const REFERRAL_FORM_1008_DEFAULT_BANNER_TITLE =
  "<h2>Greetings!</h2><p>Thank you for showing your interest.</p>";
export const REFERRAL_FORM_1008_DEFAULT_FORM_TITLE = "Send Us a Message";
export const REFERRAL_FORM_1008_DEFAULT_PRIMARY_COLOR = "#E1473F";

export const REFERRAL_FORM_1008_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    logo_image: "",
    logo_alt: "Logo",
    desktop_image: "",
    mobile_image: "",
    thank_you_mobile_image: "",
    alt_image: "Referral form background",
    banner_title: "",
    form_header_background_color: REFERRAL_FORM_1008_DEFAULT_PRIMARY_COLOR,
    form_title_text: REFERRAL_FORM_1008_DEFAULT_FORM_TITLE,
    form_title_color: "#FFFFFF",
    button_text: "Submit",
    button_text_color: "#FFFFFF",
    button_color: REFERRAL_FORM_1008_DEFAULT_PRIMARY_COLOR,
    resend_text_color: REFERRAL_FORM_1008_DEFAULT_PRIMARY_COLOR,
  },

  REFERRAL_FORM_FIELDS_CONFIG: [
    {
      fieldName: "logo_image",
      label: "Logo Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Logo Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "logo_alt",
      label: "Logo Alt Text",
      value: "Logo",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for logo",
      required: false,
      defaultValue: "Logo",
    },
    {
      fieldName: "desktop_image",
      label: "Desktop Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Background Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_image",
      label: "Mobile Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Background Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "thank_you_mobile_image",
      label: "Thank You Mobile Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Thank You Mobile Background Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Image Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for background image",
      required: false,
      defaultValue: "Referral form background",
    },
    {
      fieldName: "banner_title",
      label: "Banner Title",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter banner title and sub-title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "form_header_background_color",
      label: "Form Header Background Color",
      value: REFERRAL_FORM_1008_DEFAULT_PRIMARY_COLOR,
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select form header background color",
      required: false,
      defaultValue: REFERRAL_FORM_1008_DEFAULT_PRIMARY_COLOR,
    },
    {
      fieldName: "form_title_text",
      label: "Form Header Title",
      value: REFERRAL_FORM_1008_DEFAULT_FORM_TITLE,
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter form header title",
      required: false,
      defaultValue: REFERRAL_FORM_1008_DEFAULT_FORM_TITLE,
    },
    {
      fieldName: "form_title_color",
      label: "Form Header Title Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select form header title color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_text",
      label: "Button Text",
      value: "Submit",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter button text",
      required: false,
      defaultValue: "Submit",
    },
    {
      fieldName: "button_text_color",
      label: "Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select button text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_color",
      label: "Button Color",
      value: REFERRAL_FORM_1008_DEFAULT_PRIMARY_COLOR,
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select button color",
      required: false,
      defaultValue: REFERRAL_FORM_1008_DEFAULT_PRIMARY_COLOR,
    },
    {
      fieldName: "resend_text_color",
      label: "Resend Text Color",
      value: REFERRAL_FORM_1008_DEFAULT_PRIMARY_COLOR,
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select resend text color",
      required: false,
      defaultValue: REFERRAL_FORM_1008_DEFAULT_PRIMARY_COLOR,
    },
  ],

  METADATA_FIELDS: [],
};
